export const LEFT_NAV_ITEMS = [
  { label: "Home", href: "#home" },
  { label: "Batches", href: "#plan-tabs" },
  { label: "About", href: "#about" },
] as const;

export const RIGHT_NAV_ITEMS = [
  { label: "Blogs", href: "#blogs" },
  { label: "Resources", href: "#resources"},
  { label: "Contact", href: "#contact" },
] as const;


